<script setup lang="ts">
import MessagePlain from '@/views/chat/components/message-plain.vue'
import { computed, nextTick, reactive, ref } from 'vue'
import Watermark from '@/components/watermark.vue'
import moment from 'moment/moment'
import type { ECharts } from 'echarts'
import type { IResponseEcharts, ResponseMessageTType } from '@/types'
import { useMessageComponent } from '@/views/chat/components/composition'
import Echarts from '@/components/echarts.vue'

const props = defineProps<{ data: ResponseMessageTType<IResponseEcharts> }>()

const { plainAttrs } = useMessageComponent(props.data)
const waterContent = computed(() => {
  return sessionStorage.getItem('cwid') + ' ' + moment().format('YYYY-MM-DD')
})
const options = computed(() => {
  const optStr = props.data?.echartsResponse.options || 'return {}'
  try {
    return new Function(optStr)()
  } catch (e) {
    console.warn(`echarts错误：${optStr}`)
    return {}
  }
})
const modalVisible = ref(false)
const watermarkRef = ref()
const showEchartsDetail = ref(false)
const watermarkSize = reactive({
  width: 0,
  height: 0,
})

async function toDetail() {
  modalVisible.value = true
  await nextTick()
  watermarkSize.width = watermarkRef.value.$el.offsetWidth
  watermarkSize.height = watermarkRef.value.$el.offsetHeight
}

function onEchartsInit(charts: ECharts) {
  charts.resize()
}

async function onOpened() {
  await nextTick()
  showEchartsDetail.value = true
}

function onClosed() {
  showEchartsDetail.value = false
}
</script>

<template>
  <message-plain
    class="message-guess font-3"
    :content="data.echartsResponse.description"
    v-bind="plainAttrs"
  >
    <template #details>
      <div class="echarts-wrapper" @click="toDetail">
        <div class="abs-full">
          <echarts :options="options" style="zoom: 0.5" />
        </div>
      </div>
    </template>
  </message-plain>

  <nut-popup
    teleport-disable
    pop-class="echarts-popup"
    @opened="onOpened"
    @closed="onClosed"
    :visible="modalVisible"
    :lock-scroll="false"
  >
    <watermark
      ref="watermarkRef"
      style="background-attachment: fixed"
      :width="watermarkSize.width"
      :height="watermarkSize.height"
      :text="waterContent"
      color="#ededed"
      :font-size="16"
      :gutter-x="50"
      :gutter-y="60"
      :rotate="30"
      :offset-x="-30"
      :odd-offset-x="90"
    >
      <div
        style="flex-direction: column; display: flex; height: 100%; justify-content: center"
        v-if="showEchartsDetail"
      >
        <div style="width: 100%; height: 80%">
          <echarts :options="options" />
        </div>
        <a @click="modalVisible = false" class="back-button">返回对话</a>
      </div>
      <v-icon class="close-icon" icon="mdi-window-close" @click="modalVisible = false" />
    </watermark>
  </nut-popup>
</template>

<style scoped lang="scss">
.echarts-wrapper {
  background: linear-gradient(to bottom, #fff, #f7fdf0);
  margin-top: 0.547rem;
  height: 7.47rem;
  //height: 14.47rem;
  border: 1px solid #c2e999;
  border-radius: 0.48rem;
  width: 14rem;
  position: relative;
}

.watermark {
  width: 20rem;
  height: 100%;
  backdrop-filter: opacity(0.3);
  position: relative;
}

.close-icon {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: var(--primary-color);
  color: #fff;
  border-radius: 1rem;
  padding: 0.8rem;
}
</style>

<style lang="scss">
.echarts-popup {
  height: 100%;
  background-color: rgba(255, 255, 255, 1);
}

.back-button {
  display: block;
  background: var(--primary-color);
  color: #fff;
  text-align: center;
  padding: 0.5rem;
  border-radius: 0.3rem;
  margin: 0.5rem;
}
</style>
